import React from "react";
// import { nanoid } from "@reduxjs/toolkit";
import { useOutletContext } from "react-router-dom";
// components
import MNPGV2 from "@/components/MainPageLayouts/components/MNPGV2";
// hooks
import useMainPageItems from "@/hooks/useMainPageItems";
// types
import TMainPageItems from "./type";
import TOutletContext from "@/cms/types/TOutletContext";


// const unqKey:string = nanoid(12);

const MainPageItems = ( props:TMainPageItems ) => {
    console.log("MainPageItems.rendered: ", props);

    const { _hideLoader } = useOutletContext<TOutletContext>();
    // const mainPageTemplates = useMainPageItems({unqKey:unqKey, mapLayoutName:["MNPGGRP_003"]});
    const mainPageTemplates = useMainPageItems({mapLayoutName:"MNPGGRP_003"});

    if ( !mainPageTemplates ) return null;

    setTimeout(() => { _hideLoader(); }, 100);

    return <MNPGV2 templates={mainPageTemplates} mapLayoutName={"MNPGGRP_003"} />
}

const Component = React.memo(MainPageItems, ( prevProps:TMainPageItems, nextProps:TMainPageItems ) => {
    console.log("MainPageItems.memo", { prevProps, nextProps });
    return true;
});

export default Component;
